// extracted by mini-css-extract-plugin
export default {"deviceTableHeader":"devices_deviceTableHeader__gRebg","deviceTableHeadings":"devices_deviceTableHeadings__DRkLz","right":"devices_right__k+95g"};